<template>
  <section class="home-hero-2 mb-10 lg:mb-0" id="home-hero-2">
    <div class="container">
      <div class="flex-col lg:flex-row flex gap-3 lg:gap-8 items-center">
        <div class="order-2 w-full lg:w-1/2 flex flex-col">
          <router-link
            class="no-underline"
            :to="{
              path: `/irodak`
            }"
          >
            <img class="w-full" src="@/assets/hero2.png" alt="" />
          </router-link>
          <Button
            :to="{ path: '/irodak' }"
            arrow="right"
            class="blue inline-flex lg:hidden self-center mt-6 rounded-full"
            >Tovább az irodákhoz
          </Button>
        </div>
        <div class="order-1 hero-text w-full lg:w-1/2">
          <h1 class="h1">
            Irodabérlés <br class="hidden lg:block" />
            egyszerűen.
          </h1>
          <div class="flex flex-col sm:flex-row gap-4 mb-4 md:mb-8">
            <div class="bg-white p-2 md:p-4 rounded-full font-bold w-fit">
              <router-link
                class="no-underline"
                :to="{
                  path: `/irodak`
                }"
              >
                Térképes kereső
              </router-link>
            </div>
            <div class="bg-white p-2 md:p-4 rounded-full font-bold w-fit">
              <router-link
                class="no-underline"
                :to="{
                  path: `/irodak`
                }"
              >
                Személyre szabott lista
              </router-link>
            </div>
          </div>

          <Button
            :to="{ path: '/irodak' }"
            arrow="right"
            class="blue hidden lg:inline-flex rounded-full"
            >Tovább az irodákhoz
          </Button>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import Button from "@/components/inputs/Button.vue";

export default {
  name: "HomeHero2",
  components: {
    Button
  },
  data() {
    return {
      personal: this.$store.getters.getPersonal
    };
  }
};
</script>

<style lang="scss">
.w-fit {
  width: fit-content;
}
.home-hero-2 {
  // background-image: url("~@/assets/hero.png");
  // background-repeat: no-repeat;
  // background-position: 60% 56%;
  // background-size: 95vw;

  .h1 {
    font-size: 40px;
    line-height: 44px;
    margin-bottom: 24px;
  }

  .content {
    // max-width: 60%;
    justify-content: center;
    margin-bottom: 54px;
  }

  .hero-text {
    // margin-bottom: 105vw;
  }

  .hero-content {
    /* opacity: 0; */
    .companies {
      display: flex;
      padding: 0;
      flex-wrap: wrap;
      justify-content: center;
      li {
        flex: 0 0 50%;
        list-style: none;
        height: 80px;
        text-align: center;
        //margin-bottom: 24px;
        a {
          display: inline-block;
        }
        img {
          display: block;
          height: 80px;
          width: auto;
        }
      }
    }
  }

  .container {
    // max-width: 50%;
  }
  @media screen and (min-width: 500px) {
    .hero-text {
      // margin-bottom: 90vw;
    }
  }

  @media screen and (min-width: $breakpoint) {
    padding: 0 !important;
    background-position: 90% 40%;
    // background-size: auto 108%;
    // background-size: 52vw auto;
    background-size: 39vw;
    min-height: 632px;
    display: flex;
    align-items: center;
    .content {
      max-width: 62%;
      justify-content: flex-start;
      margin-bottom: 0;
    }

    .hero-text {
      margin-bottom: 32px;
      .h1 {
        font-size: 60px;
        margin-bottom: 40px;
        line-height: 65px;
      }
      p {
      }
    }

    .hero-content {
      margin-bottom: 64px;
      .companies {
        width: auto;
        flex-wrap: nowrap;
        justify-content: flex-start;
        //max-width: 450px;
        li {
          flex: initial;
          text-align: left;
          //margin-right: 36px;
        }
      }
    }
  }
}
</style>
